import { Flex, HoverCard, type FloatingPosition } from '@mantine/core';
import { forwardRef, type ReactElement, type ReactNode } from 'react';

type CitationPopoverProps = {
  children: ReactElement;
  content: ReactNode;
  width?: number;
  position?: FloatingPosition;
  /** When true, the target wrapper spans 100% of its container instead of shrink-to-fit. */
  fullWidthTarget?: boolean;
  onMouseEnter?: () => void;
};

const CitationPopover = forwardRef<HTMLElement, CitationPopoverProps>(
  (
    {
      children,
      content,
      width = 320,
      position = 'top',
      fullWidthTarget = false,
      onMouseEnter,
    },
    ref,
  ) => {
    return (
      <HoverCard
        width={width}
        position={position}
        withArrow
        shadow="md"
        openDelay={400}
        closeDelay={200}
        offset={-2}
        withinPortal
      >
        <HoverCard.Target>
          <Flex
            className="preserve-styles"
            component="span"
            ref={ref}
            display={fullWidthTarget ? 'flex' : 'inline-flex'}
            w={fullWidthTarget ? '100%' : undefined}
            onMouseEnter={onMouseEnter}
          >
            {children}
          </Flex>
        </HoverCard.Target>

        <HoverCard.Dropdown p={0}>{content}</HoverCard.Dropdown>
      </HoverCard>
    );
  },
);

CitationPopover.displayName = 'CitationPopover';

export default CitationPopover;
